import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import styled from '@emotion/styled'
import setMinHeightByScreen from '../../component/script/set_minheight_by_screen';
import SearchBar from '../../component/input/search_bar';
import ButtonShowRef from '../../component/button/button_show_ref';
import ButtonScroll from '../../component/button/button_scroll';
import FooterCommon from '../../component/common/footer_common';
import ItemInfo from '../../component/item/item_info';
import Toast from '../../component/common/toast';
import SkillList from '../../component/charactor/skill_list';
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from 'react-router';
import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import ReactGA from 'react-ga4';
import returnColorByString from '../../component/script/return_color_by_string';
import { Helmet } from 'react-helmet-async';


const CharactorInfoWrapper = styled.section`
    background-color: var(--color-gray-blue-100);
    > main {
        word-break: keep-all;
        box-sizing: border-box;
        width: 100%;
        max-width: 768px;
        margin: 0 auto;
        > header {
            padding: 0 20px 15px;
        }
        > nav {
            position: sticky;
            top: 0;
            padding: 10px 20px;
            background-color: var(--color-gray-blue-100);
            backdrop-filter: blur(10px);
            z-index: 256;
            ul{
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 10px;
                word-break: break-all;
                @media screen and (min-width: 768px) { 
                    gap: 12.5px;
                }
                >li {
                    &:nth-of-type(4) {
                        margin-right: auto;
                    }
                }
                button{
                    align-items: center;
                    width: 100%;
                    font-size: 12px;
                    justify-content: center;
                    background-color: transparent;
                    font-weight: 300;
                    padding: 6.5px 7.5px;
                    border-radius: 9999px;
                    font-weight: 300;
                    box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75), 2px 2px 5px 0px rgba(0, 0, 0, 0.05);
                    color: var(--color-black-200);
                    @media screen and (min-width: 768px) {
                        font-size: 15px;
                        padding: 9.5px 12.5px;
                    }
                    &.on,&:hover {
                        box-shadow: -2px -2px 10px 0px rgba(255, 255, 255, 0.75) inset, 2px 2px 10px 0px rgba(0, 0, 0, 0.05) inset;
                        color: var(--color-blue-900);
                    }
                    &.round{
                        border-radius: 50%;
                        font-weight: 700;
                        min-width: 30px;
                        min-height: 30px;
                        background-color: var(--color-gray-blue-100);
                        color: var(--color-blue-900);
                        @media screen and (min-width: 768px) {
                            border-radius: 99999px;
                            gap: 5px;
                        }
                        img {
                            display: block;
                            width: auto;
                            height: 15px;
                        }
                        span {
                            display: none;
                            @media screen and (min-width: 768px) {
                                display: block;
                            }
                        }
                    }
                }
            }

        }
        > article {
            display: flex;
            flex-flow: column;
            gap: 25px;
            padding: 0 20px 50px;
            .row-section-wrapper {
                display: flex;
                flex-flow: column;
                gap: 25px;
                @media screen and (min-width: 468px) {
                    flex-flow: row;
                }
            }
            .shadow-section {
                display: flex;
                flex-flow: column;
                width: 100%;
                gap: 25px;
                border-radius: 25px;
                padding: 25px;
                box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75) inset, 5px 5px 10px 0px rgba(0, 0, 0, 0.05) inset;
                &.charactor-short {
                    align-items: center;
                    text-align: center;
                    padding: 0 25px 25px;
                    .job-level {
                        background-color: var(--color-gray-blue-100);
                        border-radius: 0px 0px 99999px 99999px;
                        padding: 0 25px 10px;
                        box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.05);
                        line-height: 1.5;
                        .job {
                            font-size: 12px;
                        }
                        .level {
                            font-weight: 700;
                        }
                    }
                    > img {
                        display: block;
                        width: 96px;
                    }
                }
                &.charactor-basic {
                    justify-content: center;
                }
                &.charactor-stat, &.charactor-basic {
                    > article {
                        > ul{
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: space-between;
                            gap: 10px;
                            width: 100%;
                            li {
                                width: 100%;
                                display: flex;
                                justify-content: space-between;
                                > div {
                                    display: flex;
                                    align-items: center;
                                    gap: 10px;
                                }
                                h3 {
                                    font-weight: 700;
                                    color: var(--color-gray-600);
                                }
                                p {
                                    text-align: right;
                                    span {
                                        display: inline-flex;
                                        padding-right: 10px;
                                        border-right: 2px solid var(--color-gray-600);
                                        margin-right: 10px;
                                        line-height: 1;
                                    }
                                }
                            }
                        }
                        &.hyper-stat-ability {
                            ul {
                                gap: 25px;
                                li {
                                    display: block;
                                    nav {
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        div {
                                            display: flex;
                                            gap: 10px;
                                            &.off {
                                                display: none;
                                            }
                                            button {
                                                color: var(--color-black-200);
                                                align-items: center;
                                                justify-content: center;
                                                font-size: 12px;
                                                padding: 1px;
                                                min-width: 20px;
                                                aspect-ratio: 1/1;
                                                border-radius: 99999px;
                                                box-shadow: -2px -2px 2px 0px rgba(255, 255, 255, 0.75), 2px 2px 2px 0px rgba(0, 0, 0, 0.05);
                                                &.on, &:hover {
                                                    background-color: var(--color-gray-blue-300);
                                                    box-shadow: -2px -2px 2px 0px rgba(255, 255, 255, 0.0375) inset, 1px 2px 2px 0px rgba(0, 0, 0, 0.1) inset;
                                                }
                                                &.bold {
                                                    color: var(--color-blue-900);
                                                    font-weight: 700;
                                                }
                                            }
                                        }
                                    }
                                    ul{
                                        display: flex;
                                        flex-flow: column;
                                        gap: 10px;
                                        margin-top: 10px;
                                        &.off {
                                            display: none;
                                        }
                                        &.ability {
                                            font-weight: 700;
                                        }
                                        li {
                                            width: 100%;
                                        }

                                    }
                                }
                            }
                        }

                        &.union-stat {
                            display: flex;
                            flex-flow: column;
                            gap: 25px;
                            > section {
                                h3 {
                                    font-weight: 700;
                                    color: var(--color-gray-600);
                                }
                                > ul {
                                    display: flex;
                                    flex-wrap: wrap;
                                    gap: 10px;
                                    width: 100%;
                                    justify-content: space-between;
                                    margin-top: 10px;
                                    &.off {
                                        display: none;
                                    }
                                    li {
                                        width: 100%;
                                        @media screen and (min-width: 468px) {
                                            width: calc((100% - 50px)/2);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                &.charactor-stat {
                    .strong {
                        font-weight: 700;
                        text-align: right;
                        color: var(--color-black-200);
                    }
                    .combat-power {
                        font-size: 20px;
                        display: flex;
                        justify-content: space-between;
                    }
                    > article {
                        > ul {
                            li {
                                @media screen and (min-width: 486px) {
                                    width: calc((100% - 50px)/2);
                                }
                            }
                        }
                    }
                }
                &.charactor-item-equipment {
                    display: flex;
                    flex-flow: column;
                    align-items: flex-start;
                    justify-content: center;
                    gap: 50px;
                    @media screen and (min-width: 600px) {
                        flex-flow: row;
                    }
                    > article{
                        width: 100%;
                        height: 100%;
                        margin: 0 auto;
                        max-width: 350px;
                        &.item-equipment {
                            display: flex;
                            flex-flow: column;
                            gap: 25px;
                        }
                        @media screen and (min-width: 600px) {
                            width: calc((100% - 50px)/2);
                        }
                        h3 {
                            color: var(--color-gray-600);
                            font-weight: 700;
                        }
                        ul {
                            display: grid;
                            gap: 10px;
                            &.item-equipment-grid {
                                    grid-template-columns: repeat(12, 1fr);
                                > li {
                                    aspect-ratio: 1/1;
                                    &:nth-of-type(1) { grid-area: 1 / 1 / 2 / 5; }
                                    &:nth-of-type(2) { grid-area: 1 / 5 / 2 / 9; }
                                    &:nth-of-type(3) { grid-area: 1 / 9 / 2 / 13; }
                                    &:nth-of-type(4) { grid-area: 2 / 1 / 3 / 4; }
                                    &:nth-of-type(5) { grid-area: 2 / 4 / 3 / 7; }
                                    &:nth-of-type(6) { grid-area: 2 / 7 / 3 / 10; }
                                    &:nth-of-type(7) { grid-area: 2 / 10 / 3 / 13; }
                                    &:nth-of-type(8) { grid-area: 3 / 1 / 4 / 4; }
                                    &:nth-of-type(9) { grid-area: 3 / 4 / 4 / 7; }
                                    &:nth-of-type(10) { grid-area: 3 / 7 / 4 / 10; }
                                    &:nth-of-type(11) { grid-area: 3 / 10 / 4 / 13; }
                                    &:nth-of-type(12) { grid-area: 4 / 1 / 5 / 4; }
                                    &:nth-of-type(13) { grid-area: 4 / 4 / 5 / 7; }
                                    &:nth-of-type(14) { grid-area: 4 / 7 / 5 / 10; }
                                    &:nth-of-type(15) { grid-area: 4 / 10 / 5 / 13; }
                                    &:nth-of-type(16) { grid-area: 5 / 1 / 6 / 4; }
                                    &:nth-of-type(17) { grid-area: 5 / 4 / 6 / 7; }
                                    &:nth-of-type(18) { grid-area: 5 / 7 / 6 / 10; }
                                    &:nth-of-type(19) { grid-area: 5 / 10 / 6 / 13; }
                                    &:nth-of-type(20) { grid-area: 6 / 1 / 7 / 4; }
                                    &:nth-of-type(21) { grid-area: 6 / 4 / 7 / 7; }
                                    &:nth-of-type(22) { grid-area: 6 / 7 / 7 / 10; }
                                    &:nth-of-type(23) { grid-area: 6 / 10 / 7 / 13; }
                                    &:nth-of-type(24) { grid-area: 7 / 1 / 8 / 4; }
                                    &:nth-of-type(25) { grid-area: 7 / 4 / 8 / 7; }
                                    &:nth-of-type(26) { grid-area: 7 / 7 / 8 / 10; }
                                    &:nth-of-type(27) { grid-area: 7 / 10 / 8 / 13; }
                                }
                            }
                            &.item-symbol-grid {
                                margin-top: 10px;
                                grid-template-columns: repeat(3, 1fr);
                                &.off {
                                    display: none;
                                }
                                li {
                                    button {
                                        aspect-ratio: unset;
                                        background-color: var(--color-white-900);
                                        > div {
                                            color: var(--color-black-200);
                                            font-size: 12px;
                                            padding: 8px 4px;
                                            justify-content: space-between;
                                            word-break: break-all;
                                            @media screen and (min-width: 468px){
                                                padding: 8px 6px;
                                            }
                                            @media screen and (min-width: 768px) {
                                                font-size: 15px;
                                            }
                                            img{
                                                display: block;
                                                max-width: 100%;
                                                height: auto;
                                            }
                                        }
                                        
                                    }
                                }
                            }
                        }
                        li{
                            button {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 100%;
                                aspect-ratio: 1/1;
                                box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75), 2px 2px 5px 0px rgba(0, 0, 0, 0.05);
                                border-radius: 15px;
                                padding: 1px;
                                box-sizing: border-box;
                                &:hover, &.on{
                                    box-shadow: none;
                                    >div {
                                        box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.0375) inset, 2px 2px 5px 0px rgba(0, 0, 0, 0.1) inset;
                                        background-color: var(--color-gray-blue-300);
                                    }
                                    
                                }
                                > div {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding: 4px;
                                    border-radius: 14px;
                                    width: 100%;
                                    height: 100%;
                                    background-color: var(--color-gray-blue-100);
                                }
                                img {
                                    display: block;
                                    max-width: 100%;
                                }
                            }
                        }
                    }

                }
                &.charactor-skill {
                    display: flex;
                    flex-flow: column;
                    gap: 50px;
                    article {
                        >h3 {
                            color: var(--color-black-200);
                            margin-bottom: 25px;
                        }
                        > div {
                            margin-top: 10px;
                            &.off {
                                display: none;
                            }
                        }
                        button {
                            color: var(--color-black-200);
                        }
                    }
                }

                
            }
            &.no-shadow{
                background-color: var(--color-gray-blue-100);
                section{
                    background-color: var(--color-gray-blue-100);
                    article {
                        background-color: var(--color-gray-blue-100);
                    }
                }
                
            }
        }
    }
`

const ARR_ITEM_PARTS = [
    "무기", "보조무기", "엠블렘",
    "반지4", "얼굴장식", "모자", "신발",
    "반지3", "눈장식", "상의", "장갑",
    "반지2", "귀고리", "하의", "망토",
    "반지1", "펜던트2", "어깨장식", "훈장",
    "뱃지", "펜던트", "안드로이드", "기계 심장",
    "벨트", null, null, "포켓 아이템",
]

const ARR_SYMBOL_ARCANE = [
    "아케인심볼 : 소멸의 여로",
    "아케인심볼 : 츄츄 아일랜드",
    "아케인심볼 : 레헬른",
    "아케인심볼 : 아르카나",
    "아케인심볼 : 모라스",
    "아케인심볼 : 에스페라"
]

const ARR_SYMBOL_AUTHENTIC = [
    "어센틱심볼 : 세르니움",
    "어센틱심볼 : 아르크스",
    "어센틱심볼 : 오디움",
    "어센틱심볼 : 도원경",
    "어센틱심볼 : 아르테리아",
    "어센틱심볼 : 카르시온"
]

const ARR_SYMBOL_GRAND = [
    "그랜드 어센틱심볼 : 탈라하트",
]

const objectArrJobMainStat = {
    str: ["히어로", "팔라딘", "다크나이트", "소울마스터", "미하일", "블래스터", "데몬슬레이어", "아란", "카이저", "아델", "제로", "핑크빈", "바이퍼", "캐논슈터", "스트라이커", "은월", "아크", "예티", "렌"],
    int: ["아크메이지(불,독)", "아크메이지(썬,콜)", "비숍", "플레임위자드", "배틀메이지", "에반", "루미너스", "일리움", "라라", "키네시스"],
    dex: ["보우마스터", "신궁", "패스파인더", "윈드브레이커", "와일드헌터", "메르세데스", "카인"],
    luk: ["나이트로드", "섀도어", "듀얼블레이더", "나이트워커", "팬텀", "카데나", "칼리", "호영"],
    hp: ["데몬어벤져"],
    xenon: ["제논"]
}

const CharactorInfo = ()=>{
    
    const [charactorData, setCharactorData] = useState(null);
    const [areaToast, setAreaToast] = useState([]);
    const [arrHyperStat, setArrHyperStat] = useState(null);
    const [indexActiveHyperStat, setIndexActiveHyperStat] = useState(null);
    const [arrayItemObject, setArrayItemObject] = useState(null);
    const [arraySymbolArcaneObject, setArraySymbolArcaneObject] = useState(null);
    const [arraySymbolAuthenticObject, setArraySymbolAuthenticObject] = useState(null);
    const [arraySymbolGrandObject, setArraySymbolGrandObject] = useState(null);
    const location = useLocation();
    const locationState = location.state;
    const { paramCharactorName } = useParams();
    const CharactorInfoWrapperRef = useRef(null);
    const captureRef = useRef(null);
    const [charactorMainStat, setCharactorMainStat] = useState(null);
    const navigate = useNavigate();
    const [objectItem, setObjectItem] = useState(null)
    const itemInfoRef = useRef(null)
    const scrolledItem = useRef(0)

    const charactorShortRef = useRef(null);
    const charactorStatRef = useRef(null);
    const charactorItemRef = useRef(null);
    const charactorSkillRef = useRef(null);
    const charactorInfoNav = useRef(null);

    const [charactorInfoNavHeight, setCharactorInfoNavHeight] = useState(50)

    const [guildData, setGuildData] = useState(null)

    const listHyperStatRef = useRef(null);
    const buttonWrapperHyperStatRef = useRef(null);

    const listAbility = useRef(null);

    const listUnionOccupied = useRef(null);

    const listUnionRaider = useRef(null);

    const ItemSymbolGrandGridRef = useRef(null);

    const ItemSymbolAuthenticGridRef = useRef(null);

    const ItemSymbolArcaneGridRef = useRef(null);

    const skillListVRef = useRef(null);

    const skillListLinkRef = useRef(null);

    const addCommas = (number) => {
        // 숫자를 3자리씩 나누고 쉼표를 추가
        if(typeof number === "number") {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else if (typeof number === "string") {
            return Number(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else {
            return number
        }
    };

    const formatNumber = (number) => {
        const numString = String(number);
        const numArray = numString.split('');
        const resultArray = [];
        for (let i = 0; i < numArray.length; i++) {
          // 8자리마다 '억' 추가
            if (i > 0 && i % 8 === 0) {
                resultArray.unshift('억 ');
            }
      
          // 4자리마다 '만' 추가
            if (i > 0 && i % 4 === 0 && i % 8 !== 0) {
                resultArray.unshift('만 ');
            }
          resultArray.unshift(numArray[numArray.length - 1 - i]);
        }
        return resultArray.join('');
    };

    const copyToClipboard = (toastIndex) => {
        const currentUrl = window.location.href;
        // 클립보드 복사를 지원하는 브라우저인지 확인
        if (navigator.clipboard) {
          navigator.clipboard.writeText(currentUrl)
            .then(() => {
                setAreaToast(prevAreaToast => [...prevAreaToast, <Toast message="클립보드에 URL이 복사되었습니다." key={toastIndex}/>]);
            })
            .catch((error) => {
                setAreaToast(prevAreaToast => [...prevAreaToast, <Toast message={error} key={toastIndex}/>]);
            });
        } else {
            // 클립보드 복사를 지원하지 않는 경우 기존 방법 사용
            const textArea = document.createElement('textarea');
            textArea.value = currentUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy'); 
            document.body.removeChild(textArea);

            setAreaToast(prevAreaToast => [...prevAreaToast, <Toast message="클립보드에 URL이 복사되었습니다." key={toastIndex}/>]);
        }
    };
      

    const handleCapture = (toastIndex) => {

            if (captureRef.current) {
                captureRef.current.classList.add("no-shadow")
                domtoimage.toBlob(captureRef.current).then(blob => {

                    saveAs(blob, `${paramCharactorName} - 메이플스토리 전투력 측정기.png`);
                    captureRef.current.classList.remove("no-shadow")

                    setAreaToast(prevAreaToast => [...prevAreaToast, <Toast message="이미지를 저장했습니다." key={toastIndex}/>]);
                })
                .catch((error) => {
                    captureRef.current.classList.remove("no-shadow")
                    setAreaToast(prevAreaToast => [...prevAreaToast, <Toast message={error} key={toastIndex}/>]);
                });
            }
      };

    const scrollToRef = (elementRef) => {
        if (elementRef && elementRef.current) {
            window.scrollTo(
                    {
                        top: elementRef.current.offsetTop - charactorInfoNav.current.offsetHeight,
                        left: 0,
                        behavior: "smooth"
                    }
                )
        }
    }

    const getBackgroundByPotential = (top, bottom)=>{
        if ( top ) {
            return {
                background: `linear-gradient(180deg, ${returnColorByString(top, "light")} 0%, ${returnColorByString(bottom, "light")} 100%)`
            }
        } else {
            return {
                background: "#ffffff"
            }
        }
    }

    useEffect(
        ()=>{
            setObjectItem(null)
        },[location]
    )
    
    useEffect(() => {
        setMinHeightByScreen(CharactorInfoWrapperRef);
    }, [paramCharactorName, navigate]);
    
    useEffect(() => {
        if(window.location.href === `https://frieza.gabia.io/charactor-info/${encodeURI(paramCharactorName)}`) {
            window.location.href = `https://maple-frieza.com/charactor-info/${paramCharactorName}`;
        }
        ReactGA.set({
            eventCategory: "전투력 측정",
            eventLabel: paramCharactorName,
        });
        ReactGA.send("pageview");
    
    }, [paramCharactorName, ]);

    useEffect(() => {
        const fetchDataCharactor = async () => {
            try {
                const response = await axios.get(`https://maple-frieza.com/data/combat-power/${paramCharactorName}`);
                console.log(response.data, "페이지 내 요청");
                setCharactorData(response.data);
            } catch (error) {
                window.location.href = '/page-not-found';
            }
        };
    
        if (!charactorData) {
            if (locationState) {
                setCharactorData(locationState.data);
            } else {
                fetchDataCharactor();
            }
        } else if (locationState) {
            setCharactorData(locationState.data);
        }
    }, [charactorData, locationState, paramCharactorName]);

    useEffect(
        ()=>{
            const fetchDataGuild = async () => {
                try {
                    const response = await axios.get(`https://maple-frieza.com/data/guild/${charactorData.basic.world_name}/${charactorData.basic.character_guild_name}`)
                    setGuildData(response.data)
                } catch (error) {
                    console.log(error)
                }
            }

            if(charactorData) {
                if (charactorData.basic.character_guild_name) {
                    fetchDataGuild();
                }
            }

        }, [charactorData]
    )

    useEffect(
        ()=>{
            if (charactorData) {

                const newArrayItemObject = ARR_ITEM_PARTS.map((elementString) => {
                    if (elementString !== null) {
                        if(elementString === "칭호") {
                            return charactorData.itemEquipment.title
                        } else if ( elementString === "안드로이드") {
                            return charactorData.androidEquipment
                            
                        }
                        return charactorData.itemEquipment.item_equipment.find(
                            (object) => object.item_equipment_slot === elementString
                        );
                    }
                    return null;
                });
                setArrayItemObject(newArrayItemObject)

                const newArraySymbolArcaneObject = ARR_SYMBOL_ARCANE.map((elementString) => {
                    if (elementString !== null) {
                        return charactorData.symbolEquipment.symbol.find(
                            (object) => object.symbol_name === elementString
                        );
                    }
                    return null;
                });
                setArraySymbolArcaneObject(newArraySymbolArcaneObject)

                const newArraySymbolAuthenticObject = ARR_SYMBOL_AUTHENTIC.map((elementString) => {
                    if (elementString !== null) {
                        return charactorData.symbolEquipment.symbol.find(
                            (object) => object.symbol_name === elementString
                        );
                    }
                    return null;
                });
                setArraySymbolAuthenticObject(newArraySymbolAuthenticObject)

                const newArraySymbolGrandObject = ARR_SYMBOL_GRAND.map((elementString) => {
                    if (elementString !== null) {
                        return charactorData.symbolEquipment.symbol.find(
                            (object) => object.symbol_name === elementString
                        );
                    }
                    return null;
                });
                setArraySymbolGrandObject(newArraySymbolGrandObject)


                const newArrHyperStat = [
                    charactorData.hyperStat.hyper_stat_preset_1,
                    charactorData.hyperStat.hyper_stat_preset_2,
                    charactorData.hyperStat.hyper_stat_preset_3
                ]
                setArrHyperStat(newArrHyperStat)
                setIndexActiveHyperStat(charactorData.hyperStat.use_preset_no-1)
            }
        }, [charactorData]
    )

    useEffect(
        ()=>{
            const handleCharactorInfoNavHeight = ()=>{
                if(charactorData && charactorInfoNav) {
                    setCharactorInfoNavHeight(charactorInfoNav.current.offsetHeight)
                }
            }
            handleCharactorInfoNavHeight();
            window.addEventListener("resize", handleCharactorInfoNavHeight)
            return(
                ()=>{
                    window.removeEventListener("resize", handleCharactorInfoNavHeight)
                }
            )
        }, [charactorData]
    )

    useEffect(()=>{
        if( charactorData ) {
            objectArrJobMainStat.str.forEach(
                (stringJob)=>{
                    if(stringJob === charactorData.basic.character_class){
                        setCharactorMainStat("str")
                    }
                }
            )
    
            objectArrJobMainStat.int.forEach(
                (stringJob)=>{
                    if(stringJob === charactorData.basic.character_class){
                        setCharactorMainStat("int")
                    }
                }
            )
    
            objectArrJobMainStat.dex.forEach(
                (stringJob)=>{
                    if(stringJob === charactorData.basic.character_class){
                        setCharactorMainStat("dex")
                    }
                }
            )
    
            objectArrJobMainStat.luk.forEach(
                (stringJob)=>{
                    if(stringJob === charactorData.basic.character_class){
                        setCharactorMainStat("luk")
                    }
                }
            )
    
            objectArrJobMainStat.hp.forEach(
                (stringJob)=>{
                    if(stringJob === charactorData.basic.character_class){
                        setCharactorMainStat("hp")
                    }
                }
            )
    
            objectArrJobMainStat.xenon.forEach(
                (stringJob)=>{
                    if(stringJob === charactorData.basic.character_class){
                        setCharactorMainStat("xenon")
                    }
                }
            )
        }
        
    },[charactorData])
    
    return(
        <CharactorInfoWrapper ref={CharactorInfoWrapperRef}>
            <Helmet>
                <title>{paramCharactorName} - 메이플스토리 전투력 측정기</title>
            </Helmet>
            <main>
                <header>
                    <nav>
                        <h1 className="hidden">
                            메이플스토리 {paramCharactorName}의 캐릭터 정보
                        </h1>
                        <SearchBar inputValue={paramCharactorName}/>
                    </nav>
                </header>
                {
                    charactorData?
                    <>
                        <nav ref={charactorInfoNav}>
                            <ul>
                                <li>
                                    <ButtonScroll targetRef={charactorShortRef} margin={25} startAtZero={true} scrollGap={charactorInfoNavHeight*-1}>
                                        기본정보
                                    </ButtonScroll>
                                </li>
                                <li>
                                    <ButtonScroll targetRef={charactorStatRef} margin={25} scrollGap={charactorInfoNavHeight*-1}>
                                        능력치
                                    </ButtonScroll>
                                </li>
                                <li>
                                    <ButtonScroll targetRef={charactorItemRef} margin={25} scrollGap={charactorInfoNavHeight*-1}>
                                        아이템
                                    </ButtonScroll>
                                </li>
                                <li>
                                    <ButtonScroll targetRef={charactorSkillRef} margin={25} lastRef={true} scrollGap={charactorInfoNavHeight*-1}>
                                        스킬
                                    </ButtonScroll>
                                </li>
                                <li>
                                    <button className="button-share round" onClick={()=>{copyToClipboard(areaToast.length)}}>
                                        <img src="/image/icon/icon_copy_stroke_blue.svg" alt="" />
                                        <span>
                                            링크 복사
                                        </span>
                                        
                                    </button>
                                </li>
                                <li>
                                    <button className="button-save-image round" onClick={()=>{handleCapture(areaToast.length)}}>
                                        <img src="/image/icon/icon_download_stroke_blue.svg" alt="" />
                                        <span>
                                            이미지로 저장
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                        <article ref={captureRef}>
                            <div className="row-section-wrapper" ref={charactorShortRef}>
                                <section className="shadow-section charactor-short">
                                    <div className="job-level">
                                        <p className="job">{charactorData.basic.character_class}</p>
                                        <p className="level">LV. {charactorData.basic.character_level}</p>
                                    </div>
                                    <div>
                                        <img src={charactorData.basic.character_image} alt="캐릭터" />
                                        <p>
                                            {charactorData.basic.character_name}
                                        </p>
                                    </div>
                                </section>
                                <section className="shadow-section charactor-basic">
                                    <article>
                                        <ul>
                                            <li>
                                                <h3>
                                                    유니온
                                                </h3>
                                                <p>
                                                    {addCommas(charactorData.union.union_level)}
                                                </p>
                                            </li>
                                            {
                                                charactorData.dojang.dojang_best_floor?
                                                <li>
                                                    <h3>
                                                        무릉
                                                    </h3>
                                                    <p>
                                                        {charactorData.dojang.dojang_best_floor} 층
                                                    </p>
                                                </li>
                                                :null
                                            }
                                            <li>
                                                <h3>
                                                    월드
                                                </h3>
                                                <p>
                                                    {charactorData.basic.world_name}
                                                </p>
                                            </li>
                                            {
                                                charactorData.basic.character_guild_name && guildData?
                                                <li>
                                                    <h3>
                                                        길드
                                                    </h3>
                                                    <div>
                                                        {
                                                            guildData.guild.guild_mark_custom?
                                                            <img src={`data:image/png;base64,${guildData.guild.guild_mark_custom}`} alt="" />:
                                                            null
                                                        }
                                                        
                                                        <p>
                                                            {charactorData.basic.character_guild_name}
                                                        </p>
                                                    </div>
                                                </li>
                                                :null
                                            }
                                        </ul>
                                    </article>
                                </section>
                            </div>
                            <section className="shadow-section charactor-stat" ref={charactorStatRef}>
                                <h2 className="hidden">{charactorData.basic.character_name}의 능력치</h2>
                                <article className="combat-power">
                                    <h3>
                                        전투력
                                    </h3>
                                    <p className="strong">
                                        {formatNumber(charactorData.stat.final_stat[42].stat_value)}
                                    </p>
                                </article>
                                <article>
                                    <ul>
                                        <li>
                                            <h3>
                                                HP
                                            </h3>
                                            <p className={charactorMainStat === "hp"? "strong":""}>
                                                {addCommas(charactorData.stat.final_stat[20].stat_value)}
                                            </p>
                                        </li>
                                        <li>
                                            <h3>
                                                MP
                                            </h3>
                                            <p>
                                                {addCommas(charactorData.stat.final_stat[21].stat_value)}
                                            </p>
                                        </li>
                                        <li>
                                            <h3>
                                                STR
                                            </h3>
                                            <p className={charactorMainStat === "str" || charactorMainStat === "xenon"? "strong":""}>
                                                {addCommas(charactorData.stat.final_stat[16].stat_value)}
                                            </p>
                                        </li>
                                        <li>
                                            <h3>
                                                DEX
                                            </h3>
                                            <p className={charactorMainStat === "dex" || charactorMainStat === "xenon"? "strong":""}>
                                                {addCommas(charactorData.stat.final_stat[17].stat_value)}
                                            </p>
                                        </li>
                                        <li>
                                            <h3>
                                                INT
                                            </h3>
                                            <p className={charactorMainStat === "int"?"strong":""}>
                                                {addCommas(charactorData.stat.final_stat[18].stat_value)}
                                            </p>
                                        </li>
                                        <li>
                                            <h3>
                                                LUK
                                            </h3>
                                            <p className={charactorMainStat === "luk" || charactorMainStat === "xenon"?"strong":""}>
                                                {addCommas(charactorData.stat.final_stat[19].stat_value)}
                                            </p>
                                        </li>
                                        <li>
                                            <h3>아케인포스</h3>
                                            <p className="strong">{addCommas(charactorData.stat.final_stat[14].stat_value)}</p>
                                        </li>
                                        <li>
                                            <h3>어센틱포스</h3>
                                            <p className="strong">{addCommas(charactorData.stat.final_stat[15].stat_value)}</p>
                                        </li>
                                    </ul>
                                </article>
                                <article>
                                    <ul>
                                        <li>
                                            <h3>스공</h3>
                                            <p>{addCommas(charactorData.stat.final_stat[1].stat_value)}</p>
                                        </li>
                                        <li>
                                            <h3>최종뎀</h3>
                                            <p>{charactorData.stat.final_stat[4].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>데미지</h3>
                                            <p>{charactorData.stat.final_stat[2].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>보공</h3>
                                            <p>{charactorData.stat.final_stat[3].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>일몹뎀</h3>
                                            <p>{charactorData.stat.final_stat[32].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>방무</h3>
                                            <p>{charactorData.stat.final_stat[5].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>공격력</h3>
                                            <p>{addCommas(charactorData.stat.final_stat[40].stat_value)}</p>
                                        </li>
                                        <li>
                                            <h3>마력</h3>
                                            <p>{addCommas(charactorData.stat.final_stat[41].stat_value)}</p>
                                        </li>
                                        <li>
                                            <h3>크확</h3>
                                            <p>{charactorData.stat.final_stat[6].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>크뎀</h3>
                                            <p>{charactorData.stat.final_stat[7].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>쿨감</h3>
                                            <p>
                                                <span>
                                                {charactorData.stat.final_stat[33].stat_value} 초
                                                </span>
                                                {charactorData.stat.final_stat[34].stat_value} %
                                            </p>
                                        </li>
                                        <li>
                                            <h3>쿨초 확률</h3>
                                            <p>{charactorData.stat.final_stat[35].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>벞지</h3>
                                            <p>{charactorData.stat.final_stat[30].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>내성무시</h3>
                                            <p>{charactorData.stat.final_stat[36].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>상추뎀</h3>
                                            <p>{charactorData.stat.final_stat[37].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>소환수 지속</h3>
                                            <p>{charactorData.stat.final_stat[43].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>숙련도</h3>
                                            <p>{charactorData.stat.final_stat[38].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>공격속도</h3>
                                            <p>{charactorData.stat.final_stat[31].stat_value}단계</p>
                                        </li>
                                    </ul>
                                </article>
                                <article>
                                    <ul>
                                        <li>
                                            <h3>아획</h3>
                                            <p>{charactorData.stat.final_stat[28].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>메획</h3>
                                            <p>{charactorData.stat.final_stat[29].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>경험치</h3>
                                            <p>{charactorData.stat.final_stat[39].stat_value} %</p>
                                        </li>
                                        <li>
                                            <h3>스타포스</h3>
                                            <p>{charactorData.stat.final_stat[13].stat_value}</p>
                                        </li>
                                        <li>
                                            <h3>내성</h3>
                                            <p>{charactorData.stat.final_stat[8].stat_value}</p>
                                        </li>
                                    </ul>
                                </article>
                                <article className="hyper-stat-ability">
                                    <ul>
                                        {
                                            arrHyperStat 
                                            && indexActiveHyperStat!==null 
                                            && !arrHyperStat.map((element)=>{
                                                return element.every(element => !element.stat_point )
                                            }).every(element => element === true)?
                                            <li>
                                                <nav>
                                                    <ButtonShowRef arrTargetRef={[buttonWrapperHyperStatRef, listHyperStatRef]}>
                                                        <h3>하이퍼스탯</h3>
                                                    </ButtonShowRef>
                                                    <div ref={buttonWrapperHyperStatRef}>
                                                        {
                                                            arrHyperStat.map(
                                                                (element, index)=>{
                                                                    if(element.every(element => !element.stat_point)){
                                                                        return null
                                                                    }
                                                                    return <button 
                                                                            key={index}
                                                                            onClick={()=>{setIndexActiveHyperStat(index)}}
                                                                            className={`
                                                                                ${charactorData.hyperStat.use_preset_no-1===index?"bold":""}
                                                                                ${indexActiveHyperStat===index?"on":""}
                                                                            `}
                                                                            aria-label={
                                                                                `하이퍼스탯 ${index+1} 번 프리셋 보이기`
                                                                            }
                                                                        >
                                                                            {index+1}
                                                                        </button>
                                                                }
                                                            )
                                                        }
                                                    </div>
                                                </nav>
                                                <ul ref={listHyperStatRef}>
                                                    {
                                                        arrHyperStat[indexActiveHyperStat].map(
                                                            (element, index)=>{
                                                                if(!element.stat_increase){
                                                                    return null
                                                                }
                                                                return <li key={index}>
                                                                    {
                                                                        element.stat_increase
                                                                    }
                                                                </li>
                                                            }
                                                        )
                                                    }
                                                </ul>
                                            </li>
                                            :null
                                        }
                                        {
                                            charactorData.ability.ability_info?
                                            <li>
                                                <ButtonShowRef arrTargetRef={[listAbility]}>
                                                    <h3>어빌리티</h3>
                                                </ButtonShowRef>
                                                <ul className="ability" ref={listAbility}>
                                                    {
                                                        charactorData.ability.ability_info.map(
                                                            (element, index)=>{
                                                                return <li
                                                                        key={index}
                                                                        style={{color:returnColorByString(element.ability_grade)}}
                                                                    >
                                                                        {element.ability_value}
                                                                    </li>
                                                            }
                                                        )
                                                    }
                                                </ul>
                                            </li>:null
                                        }

                                    </ul>
                                </article>
                                {
                                    charactorData.unionRaider.union_occupied_stat.every(element => !element) && charactorData.unionRaider.union_raider_stat.every(element => !element)?
                                    null
                                    :<article className="union-stat">
                                        {
                                            charactorData.unionRaider.union_occupied_stat.every(element => !element)?
                                            null
                                            :<section>
                                                <ButtonShowRef arrTargetRef={[listUnionOccupied]}>
                                                    <h3>유니온 점령 효과</h3>
                                                </ButtonShowRef>
                                                <ul ref={listUnionOccupied}>
                                                    {
                                                        charactorData.unionRaider.union_occupied_stat.map(
                                                            (element, index)=>{
                                                                return (
                                                                    <li key={index}>
                                                                        {element}
                                                                    </li>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </ul>
                                            </section>
                                        }
                                        {
                                            charactorData.unionRaider.union_raider_stat.every(element => !element)?
                                            null
                                            :<section>
                                                <ButtonShowRef arrTargetRef={[listUnionRaider]}>
                                                    <h3>유니온 공격대원 효과</h3>
                                                </ButtonShowRef>
                                                
                                                <ul ref={listUnionRaider}>
                                                    {
                                                        charactorData.unionRaider.union_raider_stat.map(
                                                            (element, index)=>{
                                                                return (
                                                                    <li key={index}>
                                                                        {element}
                                                                    </li>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </ul>
                                            </section>
                                        }
                                    </article>
                                }
                                
                            </section>
                            <section className="shadow-section charactor-item-equipment" ref={charactorItemRef}>
                                <article className="item-equipment">
                                    <ul className="item-equipment-grid">
                                    {
                                        arrayItemObject?
                                        arrayItemObject.map(
                                            (element, index)=>{
                                                return(
                                                    <li key={index}>
                                                        {
                                                            element?
                                                            <button 
                                                                onClick={
                                                                    ()=>{
                                                                        setObjectItem(element)
                                                                        if(scrolledItem.current < 1) {
                                                                            scrollToRef(itemInfoRef)
                                                                            scrolledItem.current++
                                                                        }
                                                                    }
                                                                }
                                                                className={objectItem===element?"on":""}
                                                                style={getBackgroundByPotential( element.potential_option_grade, element.additional_potential_option_grade )}
                                                            
                                                            >
                                                                <div>
                                                                    <img 
                                                                    src={
                                                                        element.title_icon?
                                                                            element.title_icon
                                                                            :element.android_icon?
                                                                                element.android_icon:
                                                                                element.item_icon
                                                                        } 
                                                                        alt={
                                                                            element.title_name?
                                                                            element.title_name
                                                                            :element.android_name?
                                                                                element.android_name:
                                                                                element.item_name
                                                                        } />
                                                                </div>

                                                            </button>
                                                            :null

                                                        }
                                                    </li>
                                                )
                                            }
                                        ):null
                                    }
                                    </ul>
                                    {
                                        arraySymbolGrandObject?
                                        arraySymbolGrandObject.every(element => !element)?
                                            null
                                            :<section>
                                                <ButtonShowRef arrTargetRef={[ItemSymbolGrandGridRef]}>
                                                    <h3>그랜드 어센틱 심볼</h3>
                                                </ButtonShowRef>
                                                <ul className="item-symbol-grid" ref={ItemSymbolGrandGridRef}>
                                                    {
                                                        arraySymbolGrandObject.map(
                                                            (element, index)=>{
                                                                return(
                                                                    <li key={index}>
                                                                        {
                                                                            element?
                                                                            <button 
                                                                                onClick={
                                                                                    ()=>{
                                                                                        setObjectItem(element)
                                                                                        if(scrolledItem.current < 1) {
                                                                                            scrollToRef(itemInfoRef)
                                                                                            scrolledItem.current++
                                                                                        }
                                                                                    }
                                                                                }
                                                                                className={objectItem===element?"on":""}
                                                                            >
                                                                                <div>
                                                                                    <img 
                                                                                        src={element.symbol_icon} 
                                                                                        alt={element.symbol_name} />
                                                                                    <p>
                                                                                        {
                                                                                            element.symbol_level === 11?
                                                                                            "MAX"
                                                                                            :"LV. " + element.symbol_level
                                                                                        }
                                                                                    </p>
                                                                                </div>

                                                                            </button>
                                                                            :null

                                                                        }
                                                                    </li>
                                                                )
                                                            }
                                                        )
                                                    }
                                            </ul>
                                        </section>
                                        :null
                                    }
                                    {
                                        arraySymbolAuthenticObject?
                                        arraySymbolAuthenticObject.every(element => !element)?
                                            null
                                            :<section>
                                                <ButtonShowRef arrTargetRef={[ItemSymbolAuthenticGridRef]}>
                                                    <h3>어센틱 심볼</h3>
                                                </ButtonShowRef>
                                                <ul className="item-symbol-grid" ref={ItemSymbolAuthenticGridRef}>
                                                    {
                                                        arraySymbolAuthenticObject.map(
                                                            (element, index)=>{
                                                                return(
                                                                    <li key={index}>
                                                                        {
                                                                            element?
                                                                            <button 
                                                                                onClick={
                                                                                    ()=>{
                                                                                        setObjectItem(element)
                                                                                        if(scrolledItem.current < 1) {
                                                                                            scrollToRef(itemInfoRef)
                                                                                            scrolledItem.current++
                                                                                        }
                                                                                    }
                                                                                }
                                                                                className={objectItem===element?"on":""}
                                                                            >
                                                                                <div>
                                                                                    <img 
                                                                                        src={element.symbol_icon} 
                                                                                        alt={element.symbol_name} />
                                                                                    <p>
                                                                                        {
                                                                                            element.symbol_level === 11?
                                                                                            "MAX"
                                                                                            :"LV. " + element.symbol_level
                                                                                        }
                                                                                    </p>
                                                                                </div>

                                                                            </button>
                                                                            :null

                                                                        }
                                                                    </li>
                                                                )
                                                            }
                                                        )
                                                    }
                                            </ul>
                                        </section>
                                        :null
                                    }
                                    
                                    
                                    {
                                        arraySymbolArcaneObject?
                                        arraySymbolArcaneObject.every(element => !element)?
                                            null
                                            :<section>
                                                <ButtonShowRef arrTargetRef={[ItemSymbolArcaneGridRef]}>
                                                    <h3>아케인 심볼</h3>
                                                </ButtonShowRef>
                                                <ul className="item-symbol-grid" ref={ItemSymbolArcaneGridRef}>
                                                {
                                                    arraySymbolArcaneObject.map(
                                                        (element, index)=>{
                                                            return(
                                                                <li key={index}>
                                                                    {
                                                                        element?
                                                                        <button 
                                                                            onClick={
                                                                                ()=>{
                                                                                    setObjectItem(element)
                                                                                    if(scrolledItem.current < 1) {
                                                                                        scrollToRef(itemInfoRef)
                                                                                        scrolledItem.current++
                                                                                    }
                                                                                }
                                                                            }
                                                                            className={objectItem===element?"on":""}
                                                                        >
                                                                            <div>
                                                                                <img 
                                                                                    src={element.symbol_icon} 
                                                                                    alt={element.symbol_name} />
                                                                                <p>
                                                                                    {
                                                                                        element.symbol_level === 20?
                                                                                        "MAX"
                                                                                        :"LV. " + element.symbol_level
                                                                                    }
                                                                                </p>
                                                                            </div>

                                                                        </button>
                                                                        :null

                                                                    }
                                                                </li>
                                                            )
                                                        }
                                                    )
                                                }

                                                </ul>
                                            </section>:null
                                    }
                                    
                                </article>
                                <article ref={itemInfoRef}>
                                    <ItemInfo objectItem={objectItem} />
                                </article>
                            </section>
                            <section className="shadow-section charactor-skill" ref={charactorSkillRef}>
                                <h2 className="hidden">{paramCharactorName}의 스킬목록</h2>
                                {
                                    charactorData.skill6.character_skill.length?
                                    <article>
                                        <h3>HEXA 스킬</h3>
                                        <SkillList arrSkill={charactorData.skill6.character_skill}/>
                                    </article>
                                    :null
                                }
                                {
                                    charactorData.skill5.character_skill.length?
                                    <article>
                                        <ButtonShowRef 
                                            arrTargetRef={[skillListVRef]} 
                                            isShow={charactorData.skill6.character_skill.length?false:true}>
                                            <h3>V 스킬</h3>
                                        </ButtonShowRef>
                                        <div ref={skillListVRef}>
                                            <SkillList arrSkill={charactorData.skill5.character_skill}/>
                                        </div>
                                    </article>
                                    :null
                                }
                                {
                                    charactorData.linkSkill.character_link_skill.length?
                                    <article>
                                        <ButtonShowRef arrTargetRef={[skillListLinkRef]}
                                            isShow={charactorData.skill5.character_skill.length?false:true}
                                        >
                                            <h3>링크 스킬</h3>
                                        </ButtonShowRef>
                                        
                                        <div ref={skillListLinkRef}>
                                            <SkillList 
                                                arrSkill={charactorData.linkSkill.character_link_skill} 
                                                additionalSkill={charactorData.linkSkill.character_owned_link_skill}
                                            />
                                        </div>

                                    </article>
                                    :null
                                }
                            </section>
                        </article>
                    </>:null
                }

                {
                    areaToast
                }
                
            </main>
            <FooterCommon/>
        </CharactorInfoWrapper>
    )
}

export default CharactorInfo;